// extracted by mini-css-extract-plugin
export default {"root":"Nofunc_root__7t0z+"};